import styles from './HomePageV2.module.scss';
import { DigitalSolutionsSection } from './sections/DigitalSolutions/DigitalSolutionsSection';
import { FaqSection } from './sections/FAQ/FaqSection';
import { JobSearchHeader } from './sections/JobSearchHeader/JobSearchHeader';
import { JobsSection } from './sections/JobsSection/JobsSection';
import { LifestyleSection } from './sections/LifestyleSection/LifestyleSection';
import { PlacementTypeSection } from './sections/PlacementTypeSection/PlacementTypeSection';
import { Testimonials } from './sections/Testimonials/Testimonials';
import { WhyMedrecruit } from './sections/WhyMedrecruit/WhyMedrecruit';
import { testimonialData } from './staticData/testimonials';

interface HomePageV2Props {
  jobCount?: string | null;
}

export const HomePageV2 = ({ jobCount }: HomePageV2Props) => (
  <div className={styles.homePageV2}>
    <JobSearchHeader jobCount={jobCount} />
    <DigitalSolutionsSection />
    <JobsSection />
    <Testimonials testimonials={testimonialData} />
    <PlacementTypeSection />
    <LifestyleSection headingLevel="h2" doctorName="Dr. Dave Homewood - Registrar" />
    <WhyMedrecruit />
    <FaqSection />
  </div>
);

export default HomePageV2;
